export default {
  avatar: true
}